<template>
  <v-container
    fluid
    fill-height>
    <v-layout
      align-center
      justify-center>
      <v-flex
        xs12
        sm8
        lg6>
        <Card>
          <template slot="header">Password Reset</template>
          <v-container>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-text-field
                v-model="form.password1"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                :type="showPassword ? 'text' : 'password'"
                :rules="[rules.required]"
                label="Password"
                prepend-icon="fa-unlock-alt"
                @click:append="showPassword = !showPassword"
              />
              <v-text-field
                v-model="form.password2"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                :type="showPassword ? 'text' : 'password'"
                :rules="[rules.required, rules.passwordsMatch]"
                label="Enter Password Again"
                prepend-icon="fa-unlock-alt"
                @click:append="showPassword = !showPassword"
              />
            </v-form>
            <v-layout column>
              <v-btn
                :disabled="!valid"
                @click="submit"
              >
                Submit
              </v-btn>
              <v-flex>
                <v-layout justify-center>
                  <router-link
                    :to="{ path: '/signin/signup' }"
                    class="pa-3"
                  >
                    Sign Up
                  </router-link>
                  <router-link
                    :to="{ path: '/signin/login' }"
                    class="pa-3"
                  >
                    Login
                  </router-link>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </Card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import vuex mapping
import { mapActions } from 'vuex'

// our new component
export default {
  data () {
    return {
      valid: true,
      showPassword: false,
      form: {
        password1: null,
        password2: null
      },
      rules: {
        required: value => !!value || 'Required.',
        passwordsMatch: value => this.form.password1 === this.form.password2 || 'Passwords Must match'
      }
    }
  },
  methods: {
    ...mapActions({
      passwordReset: 'person/passwordReset'
    }),
    submit () {
      if (this.$refs.form.validate()) {
        let data = {
          password: this.form.password1,
          apiKey: this.$route.params.key
        }
        this.passwordReset(data).then(() => {
          this.$router.push('/signin/login')
        }).catch((e) => {})
      }
    }
  }
}
</script>
